module.exports = __webpack_public_path__ + "img/CompScope_Space_07.b76442af.png";